import { CLEF_OFFSETS } from './constants';
import { PreciseTimer } from '../utils/preciseTimer';

export interface PlayerUI {
  redraw(): void;
}

export interface MidiStruct {
    loadPlugin: (opts: any) => void;
    noteOn: any;
    noteOff: any;
    chordOn: any;
    chordOff: any;
    keyToNote: any;
}

export type ClefType = keyof typeof CLEF_OFFSETS;

export interface PlayInfo {
    clef: ClefType;
    defaultTime: number;
    delay: number;
    rpm: number;
}

export default class Player {
    private events: any[] = [];
    private ui: PlayerUI;
    public currentTime: number = 0;
    public currentEventIndex: number = 0;
    public ready: boolean = false;
    public playing: boolean = false;
    public callback: any;
    private scheduledId: any = null;
    public timer: PreciseTimer = new PreciseTimer();

    constructor(ui: PlayerUI) {
        this.ui = ui;

        this.loadInstrument('acoustic_grand_piano');
    }

    private loadInstrument = (instrumentName: string, onReady?: any) => {
        const player = this;
        // Initialize the player
        const MIDI: MidiStruct = window.MIDI as unknown as MidiStruct;
        MIDI.loadPlugin({
            // soundfontUrl: '../../soundfont/',
            soundfontUrl: '/soundfont/',
            instrument: instrumentName,
            callback: function () {
                player.ready = true;
                if (onReady) onReady();
            },
        });
    };

    public onPlayFinished = (callback?: any) => {
        this.callback = callback;
    };

    public addEvent = (event: any) => {
        this.events.push(event);
    };

    public addEvents = (eventList: any) => {
        this.events = this.events.concat(eventList);
    };

    public play = () => {
        let self = this;
        if (self === undefined) self = this;
        self.playing = true;
        if (self.currentEventIndex >= self.events.length) {
            self.playing = false;
            return self.callback();
        }

        var event = self.events[self.currentEventIndex];

        if (self.currentTime <= event.queuedTime) {
            //Fire the event
            self.fireEvent(event);

            //Increment the current event and add current time
            if (self.currentEventIndex + 1 >= self.events.length) {
                self.playing = false;
                return self.callback();
            }
            const timeUntilNextEvent = self.events[self.currentEventIndex + 1].queuedTime - self.events[self.currentEventIndex].queuedTime;

            self.currentEventIndex++;
            self.currentTime += timeUntilNextEvent;

            self.scheduledId = setTimeout(self.play, timeUntilNextEvent * 1000, self);
            // self.scheduledId = self.timer.setTimeout(self.play, timeUntilNextEvent * 1000)
        }
    };

    public stop = () => {
        let self = this;
        if (this.scheduledId) {
            self.timer.clearTimeout(this.scheduledId);
            this.clear();
            this.playing = false;
            while (this.events.length) {
                var event = this.events.pop();
                if (event.subtype === 'noteOff' || event.subtype === 'chordOff') this.fireEvent(event);
            }
        }
    };

    private fireEvent = (event: any) => {
        const MIDI: MidiStruct = window.MIDI as unknown as MidiStruct;
        switch (event.subtype) {
            case 'noteOn':
                MIDI.noteOn(event.channel, event.noteNumber, event.velocity, 0);
                event.note && event.note.setHighlight(true);
                this.ui.redraw();
                break;
            case 'noteOff':
                MIDI.noteOff(event.channel, event.noteNumber, 0);
                event.note && event.note.setHighlight(false);
                this.ui.redraw();
                break;
            case 'chordOn':
                MIDI.chordOn(event.channel, event.noteNumber, event.velocity, 0);
                event.note && event.note.setHighlight(true);
                this.ui.redraw();
                break;
            case 'chordOff':
                MIDI.chordOff(event.channel, event.noteNumber, 0);
                event.note && event.note.setHighlight(false);
                this.ui.redraw();
                break;
        }
    };

    private clear = () => {
        this.scheduledId = null;
        this.currentTime = 0;
        this.currentEventIndex = 0;
    };
}
